import {VariantConfigT} from '@/lib/types/colors.types';

export const purpleConfig: VariantConfigT = {
  basic: {
    icon: 'purple',
    iconHover: 'white',
    iconActive: 'white',
    hover: 'purple',
    active: 'purple',
  },
  outline: {
    icon: 'purple',
    iconHover: 'white',
    iconActive: 'white',
    hover: 'white',
    active: 'white',
  },
  ghost: {
    icon: 'purple',
    iconHover: 'purple',
    iconActive: 'purple',
    hover: 'purple',
    active: 'purple',
  },
  gradient: {
    icon: 'white',
    iconHover: 'white',
    iconActive: 'white',
    hover: 'white',
    active: 'white',
  },
  solid: {
    icon: 'white',
    iconHover: 'white',
    iconActive: 'white',
    hover: 'white',
    active: 'white',
  },
};
